import * as yup from "yup";
import * as Yup from "yup";
import { validateCompanyName } from "~/utils/companyCheckValidator";
import { countriesWithRequiredRegion } from "~/utils/utils";

export const invoiceValidator = (company, skipCompanyValidation) => {
  return yup.object().shape({
    number: yup.string().required(),
    company_name: yup.string().when("shouldValidate", {
      is: () => skipCompanyValidation,
      then: yup.string().notRequired(),
      otherwise: yup
        .string()
        .required()
        .test("company-validation", "Company validation failed", async function (value) {
          const validation = await validateCompanyName({ ...company, name: value });
          if (!validation.isValid) {
            return this.createError({ message: validation.error });
          }
          return true;
        }),
    }),
    company_id: yup.number().nullable(),
    currency_id: yup.number().required(),
    language_id: yup.number().required(),
    items: yup
      .array()
      .of(
        yup.object().shape({
          quantity: yup.number().required().min(0.01).max(9999999999.99),
          unit_cost: yup.number().required().max(999999999999.999),
          subtotal: yup.number().required().max(999999999999.999),
        })
      )
      .required(),
    issued_on: yup.date().required(),
    discount_rate: yup.number().min(0).max(100),
    qr_note: yup.string().required(),
    qr_note_content: Yup.string().when("qr_note", {
      is: "custom",
      then: Yup.string().required(),
      otherwise: Yup.string(),
    }),
    address_line_1: yup.string().when("shouldValidate", {
      is: () => skipCompanyValidation,
      then: yup.string().notRequired(),
      otherwise: yup.string().trim().required(),
    }),
    address_line_2: yup.string().trim(),
    city: yup.string().when("shouldValidate", {
      is: () => skipCompanyValidation,
      then: yup.string().notRequired(),
      otherwise: yup.string().trim().required(),
    }),
    zip_code: yup.string().when("shouldValidate", {
      is: () => skipCompanyValidation,
      then: yup.string().notRequired(),
      otherwise: yup.string().trim().required(),
    }),
    region: yup
      .string()
      .trim()
      .when("country", {
        is: (value) => countriesWithRequiredRegion.includes(value),
        then: yup.string().trim().required(),
        otherwise: yup.string().trim(),
      }),
    country: yup.string().when("shouldValidate", {
      is: () => skipCompanyValidation,
      then: yup.string().notRequired(),
      otherwise: yup.string().trim().required(),
    }),
    tax_number: yup.string().trim(),
  });
};
export const invoiceMarkPaymentValidator = yup.object().shape({
  paymentAmount: yup.number().required(),
  paymentDate: yup
    .string()
    .required()
    .test("is-valid-timestamp", null, (value) => {
      return !isNaN(value) && new Date(value).getTime() > 0;
    }),
});
